module.exports = __webpack_public_path__ + "04f7bec75ae0362a.svg";